/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "Cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('Cart:refresh', {
 *   bubbles: true
 * }));
 */
var $page = [...document.querySelector("html").classList];

theme.cart = {
  open: () => {
    var MinicartWrapper = document.querySelector(".Minicart--Wrapper");
    EvolveCore.Helpers.triggerEvent(`Cart:show`);
    let $cart = EvolveCore.Cart._store.cart;
    if ($cart) {
      gtag("event", "page_view", {
        send_to: "AW-594372835",
        value: $cart.total_price / 100,
        currency: "BRL",
        transaction_id: ``,
        ecomm_pagetype: "cart",
        ecomm_prodid: $cart.items.map((p) => p.product_id),
        ecomm_totalvalue: $cart.total_price / 100,
      });
    }
  },
  close: () => {
    var MinicartWrapper = document.querySelector(".Minicart--Wrapper");
  },
  triggerAddProductEvents: () => {
    let bodyDelegate = new domDelegate.Delegate(document.body);
    bodyDelegate.on("submit", '[action="/cart/add"]', async (e) => {
      e.stopPropagation();
      e.preventDefault();

      try {
        let $form = e.target;
        let livelo_points = await theme.livelo.getLiveloProductPoints($form);

        const data = new FormData(e.target);

        const formJSON = Object.fromEntries(data.entries());
        const formVariantIDs = formJSON.id.split(";");

        const variantsToAdd = formVariantIDs.map((variant) => {
          let props = formJSON.properties
            ? JSON.parse(formJSON.properties)
            : {};
          if (livelo_points) {
            props.livelo_points = livelo_points;
          }
          return {
            quantity: +formJSON.quantity,
            id: +variant,
            properties: props,
          };
        });

        let cart = await EvolveCore.Cart.add(variantsToAdd);

        if (livelo_points) {
          await theme.cart.setAttributes({
            enable_livelo: true,
          });
        }

        EvolveCore.Helpers.triggerEvent(
          `Cart:get`,
          EvolveCore.Cart._store.cart,
        );

        theme.cart.open();

        if (cart) {
          return $(".header_component--cart:first").click();
        }
      } catch (error) {
        console.log(error.message);
      }
    });
  },
  setAttributes: async (attributes) => {
    if (attributes) {
      await axios.post(window.Shopify.routes.root + "cart/update.js", {
        attributes,
      });
    }
  },
  setEvents: () => {
    const SELECTORS = {
      SUBTOTAL_WRAPPER: ".Minicart__Totals > div:nth-child(2)",
      CODE_WRAPPERS: {
        SELLER: ".Minicart__Area__Seller_Code",
        INFLU: ".Minicart__Area__Influ_Code",
      },
    };

    const STORAGE_KEYS = {
      SELLER: "seller_code_storage",
      INFLU: "influ_code_storage",
    };

    class CodeInputView {
      constructor(parentElement, type) {
        this.parentElement = parentElement;
        this.type = type;
        this.mounted = false;
        const cart = EvolveCore.Cart._store.cart;
        if (cart.item_count === 0) {
          return;
        }
        this.container = this.createContainer();
        this.currentCode = "";
        this.mount(this.parentElement);
        this.attachEventListeners();
      }

      attachEventListeners() {
        this.container
          .querySelector("form")
          ?.addEventListener("submit", async (event) => {
            event.preventDefault();
            const input = this.container.querySelector("input");
            const code = input?.value.trim();
            await this.applyCode(code);
          });
        this.container
          .querySelector(".Coupons__List--Item--remove")
          ?.addEventListener("click", async () => {
            await this.removeCode();
          });
        this.container
          .querySelector(".Coupons__List--Item--apply")
          ?.addEventListener("click", async (event) => {
            event.preventDefault();
            const input = this.container.querySelector("input");
            const code = input?.value.trim();
            await this.applyCode(code);
          });
      }

      async applyCode(code) {
        try {
          if (!this.mounted) {
            return;
          }
          if (!code) {
            this.showError(
              `Código do ${this.type.toLowerCase()} é obrigatório.`,
            );
            return;
          }

          // await this.removeExistingCode();

          // const codeFromStorage = CodeService.getFromStorage(this.type);
          if (this.currentCode?.toLowerCase() === code?.toLowerCase()) {
            return;
          }

          this.update(this.renderInputForm(true, code));

          const codeIsValid = await CodeService.validateCode(this.type, code);
          if (!codeIsValid) {
            this.handleInvalidCode(code);
            return;
          }

          CodeService.saveToStorage(this.type, code);
          await CodeService.updateCodeAtCart(this.type, code);

          this.update(this.renderAppliedCode(code));
          this.currentCode = code;
        } catch (error) {
          this.update(this.renderInputForm(false, code));
          this.showError(
            `Erro ao aplicar o código do ${this.type.toLowerCase()}.`,
          );
        }
      }

      async removeCode() {
        const currentCode = this.container.querySelector(
          ".Coupons__List--Item span:last-child",
        ).textContent;
        CodeService.removeFromStorage(this.type, null);
        this.update(this.renderAppliedCode(currentCode, true));
        this.currentCode = null;
        try {
          await CodeService.updateCodeAtCart(this.type, null);
          this.update(this.renderInputForm());
        } catch (error) {
          this.update(this.renderAppliedCode(currentCode));
        }
      }

      async removeExistingCode() {
        const existing = document.querySelector(
          SELECTORS.CODE_WRAPPERS[this.type.toUpperCase()],
        );
        if (existing) existing.remove();
        return;
      }

      handleInvalidCode(code) {
        CodeService.removeFromStorage(this.type, null);
        if (!this.mounted) {
          return;
        }
        this.update(this.renderInputForm(false, code));
        this.showError(`Código do ${this.type.toLowerCase()} inválido.`);
      }

      createContainer() {
        if (
          this.parentElement.querySelector(`.Minicart__Area__${this.type}_Code`)
        ) {
          return this.parentElement.querySelector(
            `.Minicart__Area__${this.type}_Code`,
          );
        }
        const container = document.createElement("div");
        container.classList.add(`Minicart__Area__${this.type}_Code`);
        return container;
      }

      mount(beforeElement) {
        if (this.mounted === true) {
          return;
        }
        this.parentElement.appendChild(this.container);
        // beforeElement.parentNode?.insertBefore(this.container, beforeElement);
        this.mounted = true;
      }

      getDisplayLabel() {
        const labels = {
          seller: "Código do vendedor",
          influ: "Código do influ",
        };
        return labels[this.type.toLowerCase()];
      }

      renderInputForm(isLoading = false, code = "") {
        if (!this.mounted) {
          return;
        }
        return `
      <div class="Minicart__Totals__Item Featured Minicart__${
        this.type
      }_Code__Form" style="display: flex;">
        <div class="Minicart__Totals__Item--Input"><label>${this.getDisplayLabel()}:</label></div>
        <div class="Minicart__Totals__Item--Output" loading="${isLoading}">
          <form><input type="text" placeholder="Insira o código" ${
            isLoading ? "disabled" : ""
          } value="${code}"></form>
          <a href="#" class="btn btn-primary Coupons__List--Item--apply" ${
            isLoading ? "disabled" : ""
          }><span>${isLoading ? "..." : "Aplicar"}</span></a>
        </div>
      </div>
    `;
      }

      renderAppliedCode(code, isLoading = false) {
        if (!this.mounted) {
          return;
        }
        return `
      <div class="Minicart__Totals__Item Featured Minicart__${
        this.type
      }_Code__Form" style="display: flex;">
        <div class="Minicart__Totals__Item--Input"><label>${this.getDisplayLabel()}:</label></div>
        <div class="Coupons__List">
          <span class="Coupons__List--Item">
            <span class="Coupons__List--Item--remove" ${
              isLoading ? "disabled" : ""
            }>
              <div class="svg__wrapper" style="${
                isLoading ? "opacity: 0.5; pointer-events: none;" : ""
              }">
                ${this.getRemoveIconSVG()}
              </div>
            </span>
            <span>${code || "..."}</span>
          </span>
        </div>
      </div>
    `;
      }

      getRemoveIconSVG() {
        return `
      <svg width="9px" height="7px" viewBox="0 0 9 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#FFF7FA" stroke-width="1" fill="none" stroke-linecap="square">
          <g transform="translate(-12.000000, -15.000000)">
            <g transform="translate(16.192388, 18.192388) rotate(-315.000000) translate(-16.192388, -18.192388) translate(11.192388, 13.192388)">
              <path d="M9.93502884,5 L0.935028843,5 M5.43502884,9.5 L5.43502884,0.5"></path>
            </g>
          </g>
        </g>
      </svg>
    `;
      }

      showError(message) {
        if (!this.mounted) {
          return;
        }
        const existingAlert = this.container.querySelector(".ev-alert");
        if (existingAlert) {
          existingAlert.querySelector("span").textContent = message;
        } else {
          const errorHTML = `
            <div class="Minicart__Totals__Item Featured">
              <div class="ev-alert" type="error"><span>${message}</span></div>
            </div>
          `;
          this.container.innerHTML += errorHTML;
          this.attachEventListeners();
        }
      }

      update(content) {
        if (!this.mounted) {
          return;
        }
        this.container.innerHTML = content;
        this.attachEventListeners();
      }
    }

    class CodeService {
      static getStorageKey(type) {
        return STORAGE_KEYS[type.toUpperCase()];
      }

      static saveToStorage(type, code) {
        if (code) {
          sessionStorage.setItem(this.getStorageKey(type), code);
        }
      }
      static removeFromStorage(type, code) {
        sessionStorage.removeItem(this.getStorageKey(type));
      }

      static getFromStorage(type) {
        return sessionStorage.getItem(this.getStorageKey(type));
      }

      static async updateCodeAtCart(type, code) {
        try {
          const attributes = {};
          attributes[`${type.toLowerCase()}_code`] = code;

          const note = code ? `${type}: ${code}` : "";

          const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              attributes,
              note,
            }),
          });
          this.saveToStorage(type, code);
          return response;
        } catch (error) {
          console.error(`Error updating ${type} code:`, error);
          throw error;
        }
      }

      static async validateCode(type, code) {
        try {
          const response = await fetch(
            `https://simpleapi-edabdzbpg2f2excy.brazilsouth-01.azurewebsites.net/${type.toLowerCase()}-codes/validate`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                code: code,
              }),
            },
          );
          const data = await response.json();
          return data.isValid;
        } catch (error) {
          console.error(`Error validating ${type} code:`, error);
          throw error;
        }
      }
    }

    class CodeManager {
      constructor(type) {
        this.type = type;
        this.view = null;
        this.container;

        this.initialize();
      }

      getCodeFromURL() {
        const urlParams = new URLSearchParams(window.location.search);

        const paramsName =
          this.type.toLowerCase() === "seller" ? "seller_code" : "influ_code";
        return urlParams.get(paramsName);
      }

      hasContainer() {
        return !!document.querySelector(`[data-code-area="${this.type}"]`);
      }
      createContainer() {
        const subTotalWrapper = document.querySelector(
          SELECTORS.SUBTOTAL_WRAPPER,
        );
        if (!subTotalWrapper) {
          return;
        }
        if (this.hasContainer()) {
          this.container = document.querySelector(
            `[data-code-area="${this.type}"]`,
          );
          return;
        }

        const container = document.createElement("div");
        container.classList.add(`Minicart__Area__Code--${this.type}`);
        container.setAttribute(`data-code-area`, this.type);

        subTotalWrapper.parentNode?.insertBefore(container, subTotalWrapper);

        this.container = document.querySelector(
          `[data-code-area="${this.type}"]`,
        );
        return container;
      }

      getStoredCode() {
        const codeFromURL = this.getCodeFromURL();
        const codeFromStorage = CodeService.getFromStorage(this.type);
        const code_stored = codeFromURL || codeFromStorage;
        if (code_stored) {
          CodeService.saveToStorage(this.type, code_stored);
        }
        return code_stored;
      }
      async initialize() {
        const cart = EvolveCore.Cart._store.cart;
        if (cart?.item_count === 0) {
          this.getStoredCode();
          return;
        } else {
          let code_stored = this.getStoredCode();
          if (!code_stored) {
            return;
          }
          if (!this.hasContainer()) {
            this.createContainer();
            this.view = new CodeInputView(this.container, this.type);
          }

          if (this.view) {
            await this.view.applyCode(code_stored);
          }
          return;
        }
      }
    }

    let sellerCodeForm;
    let influCodeForm;
    let initializeCodeManagers = () => {
      if (!sellerCodeForm) {
        sellerCodeForm = new CodeManager("seller");
      } else {
        sellerCodeForm.initialize();
      }
      if (!influCodeForm) {
        influCodeForm = new CodeManager("influ");
      } else {
        influCodeForm.initialize();
      }
    };

    function updateTicketInfo(e) {
      // Assuming 'e.cart.total_price' is available globally or passed to the function
      if (!e.total_price) {
        return;
      }
      const totalPrice = e.total_price / 100;
      const ticketValue = 250; // Ticket for every R$250
      const ticketsEarned = Math.floor(totalPrice / ticketValue);
      const amountForNextTicket = ticketValue - (totalPrice % ticketValue);
      const progressPercentage =
        ((totalPrice % ticketValue) / ticketValue) * 100;

      // Find the .Button_Buy--Wrapper element
      const buyButtonWrapper = document.querySelector(".Minicart__ProductArea");
      if (!buyButtonWrapper) {
        return;
      }
      // Remove existing ticket info if it exists
      const existingTicketInfo = document.querySelector(
        ".Minicart__Area__Tickets",
      );
      if (existingTicketInfo) {
        existingTicketInfo.remove();
      }

      const ticketInfo = document.createElement("div");
      ticketInfo.classList.add("Minicart__Area__Tickets");
      let ticketMessage = "";

      if (ticketsEarned > 0) {
        ticketMessage = `Esta compra vale <strong>${ticketsEarned}</strong> tickets da sorte, com mais <strong>R$${amountForNextTicket.toFixed(
          2,
        )}</strong> você ganha outro e concorre a um <strong>carro elétrico</strong>
        <a href="/pages/sorteio-simple-organic/">Saiba mais</a>`;
      } else {
        ticketMessage = `Com mais <strong>R$${amountForNextTicket.toFixed(
          2,
        )}</strong> você ganha um ticket da sorte e concorre a um <strong>carro elétrico</strong>
        <a href="/pages/sorteio-simple-organic/">Saiba mais</a>`;
      }

      ticketInfo.innerHTML = `
        <div class="Minicart__Ticket__Infos">
          <div class="Minicart__Ticket__Subheading">
            Concorra a um carro elétrico*
          </div>
          <div class="Minicart__Ticket__Body">
            <div class="Minicart__Ticket__Image">
            <img src="https://cdn.shopify.com/s/files/1/0469/4500/9826/files/BYD_Page_1_2.webp?v=1729727595"/>
            </div>
            <div class="Minicart__Ticket__Content">
              ${ticketMessage}
              <div class="progress-bar">
                <div class="progress-bar-fill" style="width: ${progressPercentage}%;"></div>
              </div>
            </div>
          </div>
        </div>
      `;
      buyButtonWrapper.parentNode.insertBefore(ticketInfo, buyButtonWrapper);
    }
    function updatePromotionDiscount(e) {
      function findElementByText(selectors = "*", text) {
        const elements = document.querySelectorAll(selectors); // Selects all elements
        for (const element of elements) {
          if (element.textContent.trim() === text) {
            return element;
          }
        }
        return null; // Return null if no element matches
      }

      let staticDiscountWrapper = document.querySelector(
        ".Minicart__Totals .Minicart__Totals__Discounts",
      );

      if (staticDiscountWrapper) {
        staticDiscountWrapper.remove();
      }

      let $total_cart_discounts = 0;
      let $total_product_compare_at_prices = 0;
      let $total_product_discounts = 0;

      let subtotalElement = findElementByText(
        ".Minicart__Totals .Minicart__Totals__Item--Input",
        "Subtotal:",
      );
      let discountElement = findElementByText(
        ".Minicart__Totals .Minicart__Totals__Item--Input",
        "Descontos:",
      );

      if (!e.items) {
        return;
      }

      if (!discountElement) {
        const minicartTotals = findElementByText(
          ".Minicart__Totals .Minicart__Totals__Item--Input",
          "Total:",
        );
        if (!minicartTotals) {
          return;
        }
        const minicartTotalElement = minicartTotals.parentElement;
        if (!minicartTotalElement) {
          return;
        }
        const staticDiscountElement = document.createElement("div");
        staticDiscountElement.classList.add("Minicart__Totals__Discounts");
        staticDiscountElement.classList.add("Minicart__Totals__Item");

        staticDiscountElement.innerHTML = `
          <div class="Minicart__Totals__Item--Input"><label>Descontos:</label></div><div class="Minicart__Totals__Item--Output"><span class="moneyFormat"> XXX</span></div>
        `;
        minicartTotalElement.parentNode.insertBefore(
          staticDiscountElement,
          minicartTotalElement,
        );
        discountElement = findElementByText(
          ".Minicart__Totals .Minicart__Totals__Item--Input",
          "Descontos:",
        );
      }

      const discountWrapper = discountElement.parentElement;
      const subtotalWrapper = subtotalElement.parentElement;

      if (e.applied_discounts) {
        $total_cart_discounts = e.applied_discounts.reduce((old, curr) => {
          return old + curr.amount;
        }, 0);
      }

      $total_product_compare_at_prices = e.items.reduce((old, i) => {
        let compare_at_price = i.compare_at_price || 0;
        return old + compare_at_price;
      }, 0);

      $total_product_discounts = e.items.reduce((old, i) => {
        let compare_at_price = i.compare_at_price || 0;
        let price = i.line_price;

        return old + (compare_at_price - price);
      }, 0);

      let $total_promotion_compare_at_prices =
        $total_product_compare_at_prices / 100;

      let $total_promotion_discounts = $total_product_discounts / 100;

      subtotalWrapper.querySelector(
        ".Minicart__Totals__Item--Output .moneyFormat",
      ).innerHTML = `R$ ${$total_promotion_compare_at_prices
        .toFixed(2)
        .replace(".", ",")}`;
      discountWrapper.querySelector(
        ".Minicart__Totals__Item--Output .moneyFormat",
      ).innerHTML = `R$ ${$total_promotion_discounts
        .toFixed(2)
        .replace(".", ",")}`;
    }
    function renderDiscountCodeDisclaimer(e) {
      function findElementByText(selectors = "*", text) {
        const elements = document.querySelectorAll(selectors); // Selects all elements
        for (const element of elements) {
          if (element.textContent.trim() === text) {
            return element;
          }
        }
        return null; // Return null if no element matches
      }

      let minicartBottom = document.querySelector(
        ".Minicart__Content .Minicart__Bottom",
      );
      if (!minicartBottom) {
        return;
      }

      let staticDiscountWrapper = minicartBottom.querySelector(
        ".Minicart__DiscountCodeDisclaimer",
      );

      if (staticDiscountWrapper) {
        staticDiscountWrapper.remove();
      }

      let discountElement = document.querySelector(
        ".Minicart__Content .Coupons__List .Coupons__List--Item",
      );
      if (discountElement) {
        const staticDiscountCodeDisclaimerElement =
          document.createElement("div");
        staticDiscountCodeDisclaimerElement.classList.add(
          "Minicart__DiscountCodeDisclaimer",
        );

        staticDiscountCodeDisclaimerElement.innerHTML = `
          <div class="Minicart__Alert">
            <div class="Minicart__Alert__Content">
              <span>O brinde só será adicionado se o valor mínimo da compra for mantido</span>
            </div>
          </div>
        `;
        minicartBottom.insertAdjacentElement(
          "afterbegin",
          staticDiscountCodeDisclaimerElement,
        );
      }
    }
    function renderEstimatedShippingDate(e) {
      function findElementByText(selectors = "*", text) {
        const elements = document.querySelectorAll(selectors); // Selects all elements
        for (const element of elements) {
          if (element.textContent.trim() === text) {
            return element;
          }
        }
        return null; // Return null if no element matches
      }

      let minicartBottom = document.querySelector(
        ".Minicart__Content .Minicart__Bottom",
      );
      if (!minicartBottom) {
        return;
      }

      let minicartBottomSlot = minicartBottom.querySelector(
        ".Minicart__Content .Minicart__Bottom [cart-content-slot='cart_bottom']",
      );

      if (!minicartBottomSlot) {
        const staticMinicartBottomSlotElement = document.createElement("div");
        staticMinicartBottomSlotElement.classList.add("Minicart__ContentSlot");
        staticMinicartBottomSlotElement.setAttribute(
          "cart-content-slot",
          "cart_bottom",
        );
        minicartBottom.insertAdjacentElement(
          "beforeend",
          staticMinicartBottomSlotElement,
        );
      }

      minicartBottomSlot = minicartBottom.querySelector(
        ".Minicart__Content .Minicart__Bottom [cart-content-slot='cart_bottom']",
      );

      let staticDiscountWrapper = minicartBottomSlot.querySelector(
        ".Minicart__EstimatedShippingDate",
      );

      if (staticDiscountWrapper) {
        staticDiscountWrapper.remove();
      }

      if (minicartBottomSlot) {
        const staticEstimatedShippingDateElement =
          document.createElement("div");
        staticEstimatedShippingDateElement.classList.add(
          "Minicart__EstimatedShippingDate",
        );

        staticEstimatedShippingDateElement.innerHTML = `
          <div
            estimated-delivery-date
            shipping_type="faster"
            date-mode="calculated_date"
            class="edd-block"
          ></div>

        `;
        minicartBottomSlot.insertAdjacentElement(
          "beforeend",
          staticEstimatedShippingDateElement,
        );

        return new EstimatedDeliveryDate(
          document.querySelector(
            `.Minicart__Content .Minicart__EstimatedShippingDate [estimated-delivery-date]`,
          ),
        );
      }
    }
    function renderCheckoutTotalDiscountPercentage(e) {
      function findElementByText(selectors = "*", text) {
        const elements = document.querySelectorAll(selectors); // Selects all elements
        for (const element of elements) {
          if (element.textContent.trim() === text) {
            return element;
          }
        }
        return null; // Return null if no element matches
      }

      let minicartBottom = document.querySelector(
        ".Minicart__Content .Minicart__Bottom",
      );

      if (!minicartBottom) {
        return;
      }
      let minicartBottomSlot = minicartBottom.querySelector(
        ".Minicart__Content .Minicart__Bottom [cart-content-slot='cart_bottom']",
      );

      if (!minicartBottomSlot) {
        const staticMinicartBottomSlotElement = document.createElement("div");
        staticMinicartBottomSlotElement.classList.add("Minicart__ContentSlot");
        staticMinicartBottomSlotElement.setAttribute(
          "cart-content-slot",
          "cart_bottom",
        );
        minicartBottom.insertAdjacentElement(
          "beforeend",
          staticMinicartBottomSlotElement,
        );
      }

      minicartBottomSlot = minicartBottom.querySelector(
        ".Minicart__Content .Minicart__Bottom [cart-content-slot='cart_bottom']",
      );

      let discountElement = findElementByText(
        ".Minicart__Totals .Minicart__Totals__Item--Input",
        "Descontos:",
      );
      if (!discountElement) return;
      const discountWrapper = discountElement.parentElement;

      let staticDiscountWrapper = discountWrapper.querySelector(
        ".Minicart__CheckoutTotalDiscountPercentage",
      );

      if (staticDiscountWrapper) {
        staticDiscountWrapper.remove();
      }

      if (discountWrapper) {
        const cartTotalDiscount = e.total_discount || 0;
        const cartTotalPrice = e.total_price || 0;
        const cartSubtotalPrice = e.items_subtotal_price || 0;
        if (!cartTotalDiscount) return;
        const staticCartTotalDiscountPercentageElement =
          document.createElement("div");
        staticCartTotalDiscountPercentageElement.classList.add(
          "Minicart__CheckoutTotalDiscountPercentage",
        );

        staticCartTotalDiscountPercentageElement.innerHTML = `
        <span class="label label--primary CheckoutTotalDiscountPercentage" cart-total-discount="percentage">
        ${((cartTotalDiscount / cartSubtotalPrice) * 100).toFixed()}% off
        </span>
        
        `;

        discountWrapper
          .querySelector(".Minicart__Totals__Item--Output")
          .insertAdjacentElement(
            "afterbegin",
            staticCartTotalDiscountPercentageElement,
          );
      }
    }

    document.addEventListener("_EV.Cart:updated", (e) => {
      initializeCodeManagers(e.detail);
      renderDiscountCodeDisclaimer(e.detail);
      renderEstimatedShippingDate(e.detail);
      renderCheckoutTotalDiscountPercentage(e.detail);
    });
  },
};

theme.socialsoul = {
  getQueryStringValues: function () {
    var _queryString = location.search.substring(1);
    if (!_queryString.length) {
      return;
    }
    return JSON.parse(
      '{"' + _queryString.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      },
    );
  },
  setCookie: function (name, value, days = 1) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name +
      "=" +
      (value || "") +
      expires +
      "; domain=.simpleorganic.com.br;path=/";
  },
  getCookie: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  deleteCookie: function (name) {
    document.cookie =
      name +
      "=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.simpleorganic.com.br";
  },
  _initStoreTracking: function () {
    var queryStringValues = theme.socialsoul.getQueryStringValues();
    if (!queryStringValues) {
      return;
    }
    if (
      queryStringValues.utm_source &&
      queryStringValues.utm_source === "socialsoul" &&
      queryStringValues.lmdsid
    ) {
      theme.socialsoul.setCookie(
        "socialsoul.source",
        queryStringValues.utm_source,
      );
      theme.socialsoul.setCookie(
        "socialsoul.campaign",
        queryStringValues.utm_medium,
      );
      theme.socialsoul.setCookie("socialsoul.param", queryStringValues.lmdsid);
    } else {
      theme.socialsoul.deleteCookie("socialsoul.source");
      theme.socialsoul.deleteCookie("socialsoul.campaign");
      theme.socialsoul.deleteCookie("socialsoul.param");
    }
  },
  _initPurchaseTracking: function () {
    if (getCookie("socialsoul.source")) {
      // execute the code
    }
  },
};
theme.livelo = {
  isLiveloPage: () => {
    let isLiveloPage = false;
    const utm_params = window.SimpleCore._helpers.getUtmParams();
    if (
      window.location.pathname === "/pages/livelo" ||
      window.location.pathname === "/collections/livelo"
    ) {
      isLiveloPage = true;
    }

    if (utm_params && utm_params.utm_source === "livelo") {
      isLiveloPage = true;
    }
    return isLiveloPage;
  },
  setLiveloCookie(
    name = "rewards_program",
    value = "optin_livelo:true",
    expHours = 1,
  ) {
    let date = new Date();
    date.setTime(date.getTime() + expHours * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie =
      name +
      "=" +
      value +
      "; " +
      expires +
      "; domain=simpleorganic.com.br; path=/";
  },
  deleteLiveloCookie(
    name = "rewards_program",
    value = "optin_livelo:true",
    expHours = 1,
  ) {
    // Define a data de expiração para uma data no passado
    document.cookie =
      name +
      "=" +
      value +
      "; " +
      "expires=Thu, 01 Jan 1970 00:00:00 UTC" +
      "; domain=simpleorganic.com.br; path=/";
  },
  hasLiveloCookie: () => {
    let rewardsProgramCookie = theme.livelo.getRewardsProgramCookie();
    if (!!rewardsProgramCookie) {
      let hasLiveloCookie = rewardsProgramCookie.includes("optin_livelo:true");
      if (!!hasLiveloCookie) {
        return true;
      }
    }
    return false;
  },
  getRewardsProgramCookie: () => {
    const name = "rewards_program";
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return;
  },
  renderLiveloHeaderWidget: async () => {
    for (
      let i = 0;
      i < document.querySelectorAll("[data-livelo-header-announcement]").length;
      i++
    ) {
      const liveloWidget = document.querySelectorAll(
        "[data-livelo-header-announcement]",
      )[i];
      if (liveloWidget) {
        // liveloWidget.innerHTML = `
        //   <span class="livelo__header__announcement__container">
        //     Ganhe <b>1 ponto Livelo por real gasto*</b> em produtos
        //     <a href="/collections/produtos-com-fps">
        //       <b>Ver todos os produtos</b>
        //     </a>
        //   </span>
        // `;
      }
    }
  },
  renderLiveloWidget: async () => {
    for (
      let i = 0;
      i < document.querySelectorAll("[data-livelo-widget]").length;
      i++
    ) {
      const liveloWidget = document.querySelectorAll("[data-livelo-widget]")[i];
      const liveloPoints = +liveloWidget.getAttribute("data-livelo-points");
      if (liveloWidget && liveloPoints) {
        liveloWidget.querySelector("[data-livelo-widget-points]").innerHTML =
          `${liveloPoints} pontos`;
      }
    }
  },
  renderLiveloComponents: async () => {
    let rewardsProgramCookie = theme.livelo.getRewardsProgramCookie();
    let isLiveloPage = theme.livelo.isLiveloPage();
    if (!!rewardsProgramCookie || isLiveloPage) {
      let hasLiveloCookie = rewardsProgramCookie.includes("optin_livelo:true");
      if (!!hasLiveloCookie || isLiveloPage) {
        document.body.setAttribute("data-enable-livelo", true);
        theme.livelo.renderLiveloWidget();
        theme.livelo.renderLiveloHeaderWidget();
      }
    }
  },
  getLiveloProductPoints: async ($form) => {
    if (!theme.livelo.hasLiveloCookie()) {
      return;
    }
    let livelo_widget = $form.querySelector("[data-livelo-points]");
    let livelo_points, product_quantity;
    if (livelo_widget) {
      const data = new FormData($form);
      const formJSON = Object.fromEntries(data.entries());

      product_quantity = +formJSON.quantity;
      livelo_points = +livelo_widget.getAttribute("data-livelo-points");
      if (livelo_points > 0 && product_quantity > 0) {
        return livelo_points * product_quantity;
      }
    }
    return;
  },
  setEvents: async () => {
    const utm_params = window.SimpleCore._helpers.getUtmParams();
    let first_access_info =
      window.SimpleCore._helpers.getCookie("first_access_info");

    if (!first_access_info) {
      function prefixObjectProperties(obj, prefix) {
        const prefixedObj = {};

        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            prefixedObj[prefix + key] = obj[key];
          }
        }

        return prefixedObj;
      }
      let first_access_object = prefixObjectProperties(
        {
          created_at: new Date().toISOString(),
          traffic_type: utm_params ? "paid_traffic" : "non_paid_traffic",
          ...utm_params,
        },
        "first_access_",
      );
      window.SimpleCore._helpers.setCookie(
        "first_access_info",
        JSON.stringify(first_access_object),
        15,
      );
      first_access_info =
        window.SimpleCore._helpers.getCookie("first_access_info");
    }
    if (first_access_info) {
      await theme.cart.setAttributes(JSON.parse(first_access_info));
    }

    document.querySelectorAll("[data-trigger-livelo]").forEach((element) => {
      element.addEventListener("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        theme.livelo.setLiveloCookie();
      });
    });
    if (window.location.pathname === "/") {
      // theme.livelo.deleteLiveloCookie();
    }
    if (
      window.location.pathname === "/pages/livelo" ||
      window.location.pathname === "/collections/livelo"
    ) {
      theme.livelo.setLiveloCookie();
    }

    if (utm_params && utm_params.utm_source === "livelo") {
      theme.livelo.setLiveloCookie();
    }

    document.addEventListener("_EV.Cart:updated", (e) => {
      if (document.querySelector(".Minicart__Totals__Item.Featured")) {
        if (
          !!EvolveCore.Cart._store.cart.items.find(
            (i) => i.properties.livelo_points,
          )
        ) {
          document.querySelector(
            ".Minicart__Totals__Item.Featured",
          ).style.display = "none";
        } else {
          document.querySelector(
            ".Minicart__Totals__Item.Featured",
          ).style.display = "flex";
        }
      }
    });
  },

  _init: async () => {
    await theme.livelo.setEvents();
    await theme.livelo.renderLiveloComponents();
  },
};

theme.homepage = {
  variables: {},
  init: async () => {
    await theme.homepage.set_events();
  },
  set_events: async () => {},
};

theme.newsletter_popup = {
  variables: {},
  _onNewsletterError: ($popup) => {
    let $formStep = $popup.querySelector('[data-step="form"]');
    let $errorStep = $popup.querySelector('[data-step="error"');
    $formStep.style.display = "none";
    $errorStep.style.display = "block";
  },
  _onNewsletterSuccess: ($popup) => {
    let $formStep = $popup.querySelector('[data-step="form"]');
    let $successStep = $popup.querySelector('[data-step="success"');
    $formStep.style.display = "none";
    $successStep.style.display = "block";
  },
  _onNewsletterReset: ($popup) => {
    let $formStep = $popup.querySelector('[data-step="form"]');
    let $errorStep = $popup.querySelector('[data-step="error"');
    let $successStep = $popup.querySelector('[data-step="success"');
    $formStep.style.display = "block";
    $successStep.style.display = "none";
    $errorStep.style.display = "none";
  },
  _init: async () => {
    await theme.newsletter_popup.set_events();
  },
  set_events: async (e) => {
    for (const $form of document.querySelectorAll(
      '.NewsletterPopup [data-step-redirect="form"]',
    )) {
      $form.addEventListener("click", async (e) => {
        let $popup = e.target.closest(".NewsletterPopup");
        theme.newsletter_popup._onNewsletterReset($popup);
      });
    }
    document.addEventListener(`so.popup:validation:email:error`, async (e) => {
      let $popup = e.detail.$element;
      if ($popup) {
        let $email = $popup.querySelector('[data-input-group="email"]');
        $email.setAttribute("data-validation", "error");
      }
    });
    document.addEventListener(`so.popup:conversion`, async (e) => {
      let $popup = e.detail.$element;
      if ($popup) {
        try {
          let $email = $popup.querySelector('[name="contact[email]"]');
          await window.SimpleCore.customer_auth.sign_in_newsletter_rdstation(
            $email.value,
          );

          theme.newsletter_popup._onNewsletterSuccess($popup);
        } catch (error) {
          theme.newsletter_popup._onNewsletterError($popup);
        }
      }
    });
  },
};

theme.whatsapp_widget = {
  variables: {},
  _init: async () => {
    let render_widget = (s, u, i, t, e) => {
      var share = s.createElement("script");
      share.async = true;
      share.id = "suiteshare";
      share.src = "https://static.suiteshare.com/widgets.js";
      share.setAttribute("init", i);
      s.head.appendChild(share);
    };
    render_widget(
      document,
      "script",
      "b0772577aab68faff9fe9b2fd0e8aa0204d99ebe",
    );
  },
  set_events: async (e) => {},
};
theme.accordion = {
  variables: {},
  _init: async () => {
    const accordionItems = document.querySelectorAll(
      ".Accordion__Item:not(.Accordion__Item--static)",
    );

    accordionItems.forEach(function (item) {
      const header = item.querySelector(".Accordion__Title");
      const content = item.querySelector(".Accordion__Content");

      header.addEventListener("click", function () {
        theme.accordion.toggle_item(item);
      });
    });
  },
  toggle_item: async (item) => {
    if (item) {
      const accordionItems = document.querySelectorAll(
        ".Accordion__Item:not(.Accordion__Item--static)",
      );

      // Toggle active class on content
      item.classList.toggle("active");

      // Close other accordion items
      accordionItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          otherItem.classList.remove("active");
        }
      });
    }
  },
  set_events: async (e) => {},
};

// data-slideshow-name="homepage-main-slider"
window.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('[href*="/cart"]').forEach((element) => {
    element.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      theme.cart.open();
    });
  });
  document
    .querySelectorAll(".Minicart--Wrapper .backdrop")
    .forEach((element) => {
      element.addEventListener("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        theme.cart.close();
      });
    });
  document.addEventListener("_EV.Cart:hide", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    theme.cart.close();
  });

  document.addEventListener("_EV.cart:hide", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    theme.cart.close();
  });
  theme.socialsoul._initStoreTracking();
  theme.cart.triggerAddProductEvents();
  theme.livelo._init();
  theme.newsletter_popup._init();
});
document.addEventListener("_EV.core:initialized", async (e) => {
  if (window.location.search === "?redirect_cart") {
    theme.cart.open();
  }
});
document.addEventListener("_EV.core:initialized", async (e) => {
  if (window.location.search === "?redirect_cart") {
    theme.cart.open();
  }
});
document.addEventListener(
  "quizKitResultsPageLoaded",
  async (e) => {
    let sleep = (ms) => {
      return new Promise((resolve) => setTimeout(resolve, ms));
    };

    let quizInfo = e.detail;
    console.log("quizInfo", quizInfo);

    await sleep(1000);

    let productCustomRecommendationMain = [
      ...document.querySelectorAll(
        '[data-custom-product-recommendations="main"]',
      ),
    ];
    let resultsPageUserInfo = document.querySelector(
      '[data-section-id="headings_4"]',
    );

    let productCustomRecommendationSecondary = [
      ...document.querySelectorAll(
        '[data-custom-product-recommendations="secondary"]',
      ),
    ];

    let QuizSkinType = () => {
      let quizSkinTypeAnswer = quizInfo.answers.find((a) => {
        return a.questionId === 155553;
      })?.selectedAnswers[0]?.value;
      if (!quizSkinTypeAnswer) return "Pele Mista";

      switch (quizSkinTypeAnswer.toLowerCase()) {
        case "oleosa":
          return "Pele Oleosa";
        case "seca":
          return "Pele Seca";
        case "mista":
          return "Pele Mista";
        case "sem característica marcante":
          return "Sem característica marcante";
        default:
          return "Pele Mista";
      }
    };
    let QuizSkinNeeds = () => {
      let translateSkinNeed = (skin_need) => {
        switch (skin_need.toLowerCase()) {
          case "cravos e espinhas":
            return "Cravos e espinhas";
          case "sensibilidade e/ou vermelhidão":
            return "Sensibilidade e/ou vermelhidão";
          case "linhas finas e de expressão":
            return "Linhas finas e de expressão";
          case "oleosidade excessiva":
            return "Oleosidade excessiva";
          case "olheiras e bolsas":
            return "Olheira e bolsas";
          case "ressecamento":
            return "Ressecamento";
          case "poros dilatados":
            return "Poros dilatados";
          case "falta de firmeza e elasticidade":
            return "Firmeza e elasticidade";
          case "manchas escurecidas":
            return "Manchas escurecidas";
          default:
            return "Cravos e espinhas";
        }
      };

      let quizSkinNeedAnswers = quizInfo.answers
        .find((a) => {
          return a.questionId === 155554;
        })
        ?.selectedAnswers.map((a) => translateSkinNeed(a.value));

      if (!quizSkinNeedAnswers.length) return null;

      return quizSkinNeedAnswers;
    };
    let QuizSkinCharacteristics = () => {
      let quizSkinCharacteristicAnswer = quizInfo.answers.find((a) => {
        return a.questionId === 155555;
      })?.selectedAnswers[0]?.value;
      if (!quizSkinCharacteristicAnswer) return null;

      switch (quizSkinCharacteristicAnswer.toLowerCase()) {
        case "sensível":
          return "Pele sensível";
        case "pele madura":
          return "Pele Madura";
        case "sensível e madura":
          return "Sensível e madura";
        case "nenhum dos dois":
          return "Nenhum dos dois";
        default:
          return "Nenhum dos dois";
      }
    };
    const prioritizedTags = ["__label:Best-Seller", "__label:Lançamento"];

    let productTechnicalInfos =
      await window.SimpleCore.shopifyStorefront.getPublishedProductsWithMetafields();

    let matchedProducts = productTechnicalInfos
      .filter((p) => p.skin_type?.includes(QuizSkinType()))
      .filter((p) =>
        QuizSkinNeeds().some((item) => {
          if (!p.skin_needs) {
            p.skin_needs = [];
          }
          return p.skin_needs.includes(item);
        }),
      )
      .filter((p) =>
        p.skin_characteristics?.includes(QuizSkinCharacteristics()),
      )
      .filter((p) => p.availability === null)
      .sort((a, b) => {
        const aPriority = a.tags.some((tag) => prioritizedTags.includes(tag))
          ? 1
          : 0;
        const bPriority = b.tags.some((tag) => prioritizedTags.includes(tag))
          ? 1
          : 0;

        return bPriority - aPriority; // Prioriza os que possuem a tag
      });

    matchedProducts = matchedProducts.map((p) => {
      return {
        ...p,
        category: p.quiz_category ? p.quiz_category[0] : "",
      };
    });

    quizInfo.recommendedProducts = quizInfo.recommendedProducts.map((p) => {
      let technicalInfos = productTechnicalInfos.find(
        (inf) => inf.title === p.title,
      );
      let quizCategory = productTechnicalInfos.find(
        (inf) => inf.title === p.title,
      )?.quiz_category;
      return {
        ...p,
        ...technicalInfos,
        category: quizCategory ? quizCategory[0] : null,
      };
    });

    let mainProductRecommendations = matchedProducts.filter(
      (p) => p.category.toLowerCase() !== "dica extra",
    );

    let secondaryProductRecommendations = matchedProducts.filter(
      (p) => p.category.toLowerCase() === "dica extra",
    );

    let userName =
      quizInfo?.answers
        ?.find((a) => a.questionId === 155556)
        ?.selectedAnswers?.find((v) => v.value)?.value || null;
    quizInfo.userData.userName = userName;

    let renderMainProductCard = (product) => {
      if (!product) {
        return "";
      }
      return `
          <div class="quiz-results__product-card quiz-results__product-card--main">
            <div class="quiz-results__product-card__image">
              <img src="${product.image.src}" alt="${product.title}">
            </div>
            <div class="quiz-results__product-card__content">
              <span class="quiz-results__product-card__title">${
                product.title
              }</span>
              <span class="quiz-results__product-card__tagline">${
                product.tagline || ""
              }</span>
            </div>
            <div class="quiz-results__product-card__footer">
              <a href="#" data-variant-id="${product.variants[0].id}">
                Comprar
              </a>
            </div>
          </div>
        `;
    };
    let renderSecondaryProductCard = (product) => {
      if (!product) {
        return "";
      }
      return `
          <div class="quiz-results__product-card quiz-results__product-card--main">
            <div class="quiz-results__product-card__image">
              <img src="${product.image.src}" alt="${product.title}">
            </div>
            <div class="quiz-results__product-card__content">
              <span class="quiz-results__product-card__title">${
                product.title
              }</span>
              <span class="quiz-results__product-card__price">
                R$ ${product.price.toFixed(2).replace(".", ",")}
              </span>
              <span class="quiz-results__product-card__tagline">${
                product.tagline
              }</span>
              </div>
            <div class="quiz-results__product-card__footer">
              <a href="#" data-variant-id="${product.variants[0].id}">
                Comprar
              </a>
            </div>
          </div>
        `;
    };

    let renderMainRecommendations = () => {
      let mainRecommendations = "";
      let productCategories = [
        ...new Set(
          mainProductRecommendations
            .map((p) => {
              let categoryStep = 9999;
              let categoryHandle = p?.category?.toLowerCase();
              if (categoryHandle === "limpeza") {
                categoryStep = 1;
              }
              if (categoryHandle === "tratamento") {
                categoryStep = 2;
              }
              if (categoryHandle === "hidratação") {
                categoryStep = 3;
              }
              return { title: p.category || "", step: categoryStep };
            })
            .sort((a, b) => {
              return a.step - b.step;
            }),
        ),
      ];
      productCategories = Array.from(
        new Map(
          productCategories.map((item) => [`${item.title}|${item.step}`, item]),
        ).values(),
      );

      let renderProductCategory = (category) => {
        if (!category) {
          return "";
        }
        let categoryProducts = mainProductRecommendations.filter((p) => {
          return p.category === (category.title ? category.title : undefined);
        });

        if (!categoryProducts || !categoryProducts.length) {
          theme.event_tracker.event("Quiz:ProductNotFound", {
            section_type: "quiz:result_page",
            combination: `
              ${QuizSkinType()} > ${QuizSkinNeeds()} > ${QuizSkinCharacteristics()} > ${
                category.title
              }
            `,
          });
          return "";
        }
        theme.event_tracker.event("Quiz:ProductFound", {
          section_type: "quiz:result_page",
          combination: `
            ${QuizSkinType()} > ${QuizSkinNeeds()} > ${QuizSkinCharacteristics()} > ${
              category.title
            }
          `,
        });
        let renderMainProductList = (categoryProducts) => {
          let productList = "";
          if (!categoryProducts) {
            return ``;
          }
          for (const product of categoryProducts.slice(0, 2)) {
            productList += renderMainProductCard(product);
          }
          return productList;
        };
        return `
        <div class="quiz-results__category--main" data-category="${category?.title?.toLowerCase()}">
          <div class="quiz-results__category__infos">
            <span class="quiz-results__category__step">${
              category.step < 9999 ? category.step : ""
            }</span>
            <span class="quiz-results__category__title">${category.title}</span>
          </div>
          <div class="quiz-results__category__product-list">
          ${renderMainProductList(categoryProducts)}
          </div>
        </div>
        `;
      };
      for (const category of productCategories) {
        mainRecommendations += renderProductCategory(category);
      }
      return mainRecommendations;
    };
    let renderSecondaryRecommendations = () => {
      let secondaryRecommendations = "";

      let renderProductCategory = (category) => {
        if (!category || !category.title) {
          return "";
        }
        let categoryProducts = secondaryProductRecommendations;
        if (!categoryProducts || !categoryProducts.length) {
          return "";
        }

        let renderSecondaryProductList = (categoryProducts) => {
          let productList = "";
          if (!categoryProducts) {
            return ``;
          }
          for (const product of categoryProducts) {
            productList += renderSecondaryProductCard(product);
          }
          return productList;
        };

        return `
        <div class="quiz-results__category--secondary" data-category="${category.title.toLowerCase()}">
          <div class="quiz-results__category__product-list">
          ${renderSecondaryProductList(categoryProducts)}
          </div>
        </div>
        `;
      };

      secondaryRecommendations += renderProductCategory({ title: "secondary" });
      return secondaryRecommendations;
    };

    if (resultsPageUserInfo && userName) {
      resultsPageUserInfo.innerHTML = resultsPageUserInfo.innerHTML.replace(
        "[user_name]",
        userName,
      );
      resultsPageUserInfo.style.display = "block";
    }
    for (const mainRecommendation of productCustomRecommendationMain) {
      mainRecommendation.innerHTML = renderMainRecommendations();
    }
    for (const secondaryRecommendation of productCustomRecommendationSecondary) {
      secondaryRecommendation.innerHTML = renderSecondaryRecommendations();
    }

    [
      ...document.querySelectorAll("#quiz-kit-content [data-variant-id]"),
    ].forEach((button) => {
      button.addEventListener("click", async (e) => {
        e.preventDefault();
        await sleep(550);
        await EvolveCore.Cart.add([
          {
            quantity: 1,
            id: +button.getAttribute("data-variant-id"),
          },
        ]);
        EvolveCore.Helpers.triggerEvent(
          `Cart:get`,
          EvolveCore.Cart._store.cart,
        );
        theme.cart.open();
      });
    });
  },
  false,
);
function interceptAndTransformXHRResponses() {
  // Save the original XMLHttpRequest's open and send methods
  let originalXHR = XMLHttpRequest;
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  // Override XMLHttpRequest's open method to save the URL
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  // Override XMLHttpRequest's send method to intercept and transform responses
  XMLHttpRequest.prototype.send = function () {
    let xhr = this;
    const originalOnReadyStateChange = xhr.onreadystatechange;

    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status < 400) {
        if (xhr._url.includes("/cart")) {
        }
        if (xhr._url === "/cart/add.js" || xhr._url === "/cart/add") {
          Helpers.triggerEvent(`Cart:hooked`, JSON.parse(xhr.responseText));
        }
      }
      // Call the original onreadystatechange, if any
      if (originalOnReadyStateChange) {
        originalOnReadyStateChange.apply(xhr, arguments);
      }
    };
    return originalSend.apply(xhr, arguments);
  };
}

// Check if the browser supports the fetch API
function interceptAndTransformFetchResponses() {
  const originalFetch = window.fetch;

  window.fetch = function (url, options) {
    return originalFetch(url, options).then((response) => {
      if (response.status < 400 && url.includes("/cart")) {
      }
      if (
        response.status < 400 &&
        (url === "/cart/add.js" || url === "/cart/add")
      ) {
        return response.text().then((text) => {
          return Helpers.triggerEvent(`Cart:hooked`, JSON.parse(text));
        });
      }

      return response;
    });
  };
}

interceptAndTransformFetchResponses();
interceptAndTransformXHRResponses();

class Button {
  constructor(button) {
    this.button = button;
  }
  loading(status) {
    if (status) {
      this.button.classList.add("Button--loading");
      this.button.classList.add("btn--loading");
      return;
    }
    this.button.classList.remove("Button--loading");
    this.button.classList.remove("btn--loading");
    return;
  }
}
class UserAccountSection {
  constructor(container) {
    this.element = container;
    this.target = document.querySelector('[role="main"]');
    this.steps = this.element.querySelectorAll("[data-step]");
    this.setEvents();
  }

  onUnload() {
    this.carousel.destroy();
  }

  setEvents() {
    for (const step of this.steps) {
      step.addEventListener("click", (e) => {
        window.scrollTo(0, 0);
        window.SimpleCore._helpers.triggerEvent(
          `account:navigation:click:${e.currentTarget.getAttribute(
            "data-step",
          )}`,
        );
      });
    }

    setTimeout(() => {
      this.setInitialStep();
    }, 1000);
  }

  setInitialStep() {
    this.setMyAccountStep();
  }

  setMyAccountStep() {
    let customerAccountSections = this.target.querySelectorAll(
      ".user-account__main .shopify-section:not(.shopify-section--customers-account-order-list)",
    );
    let orderListSections = this.target.querySelectorAll(
      ".user-account__main .shopify-section.shopify-section--customers-account-order-list",
    );
    for (const section of customerAccountSections) {
      section.style.display = "block";
    }
    for (const section of orderListSections) {
      section.style.display = "none";
    }
  }

  setOrderListStep() {
    let customerAccountSections = this.target.querySelectorAll(
      ".user-account__main .shopify-section:not(.shopify-section--customers-account-order-list)",
    );
    let orderListSections = this.target.querySelectorAll(
      ".user-account__main .shopify-section.shopify-section--customers-account-order-list",
    );
    for (const section of customerAccountSections) {
      section.style.display = "none";
    }
    for (const section of orderListSections) {
      section.style.display = "block";
    }
  }
}
class CustomerOrderWidget {
  constructor(container, customerEmail, customerFirstName, customerLastName) {
    this.widget = container;
    this._init();
  }
  _init() {
    this._setEvents();
  }
  _setEvents() {
    let reOrderBtn = this.widget.querySelector('[data-order-action="reorder"]');

    if (reOrderBtn) {
      const reOrder = async () => {
        const reOrderItems = reOrderBtn.getAttribute("data-reorder-items");

        if (reOrderItems) {
          const reOrderObj = reOrderItems
            .split(";")
            .filter((o) => o.length)
            .map((item) => {
              const [variant, quantity] = item.split(":");
              return { id: +variant, quantity: +quantity };
            });

          await EvolveCore.Cart.add(reOrderObj);

          EvolveCore.Helpers.triggerEvent(
            `Cart:get`,
            EvolveCore.Cart._store.cart,
          );

          theme.cart.open();
        }
      };

      reOrderBtn.addEventListener("click", (e) => {
        e.preventDefault();
        reOrder();
      });
    }
  }
}
class ProductCatalogPage {
  constructor(container) {
    this.element = container;
    this.quickViewModalID = "catalog-quickview--modal";

    this._attachListeners();
    this._setNavigation();
  }

  onUnload() {
    window.removeEventListener("scroll", this._onScrollListener);
  }

  _attachListeners() {
    let $this = this;
  }

  async _setNavigation() {
    let ButtonLinksList = document.querySelector(".ButtonLinksList__Wrapper");
    if (ButtonLinksList) {
      let setButtonLinksListNavigation = () => {
        let ButtonLinksListItems = ButtonLinksList.querySelectorAll(
          ".ButtonLinksList__Item",
        );
        for (const ButtonLinksListItem of ButtonLinksListItems) {
          ButtonLinksListItem.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let CollectionProductList = document.querySelector(
              `.ProductListWrapper[data-collection="${ButtonLinksListItem.getAttribute(
                "data-collection",
              )}"]`,
            );
            if (CollectionProductList) {
              window.SimpleCore._helpers.scrollTo(CollectionProductList, -200);
            }
          });
        }
      };
      setButtonLinksListNavigation();
    }
  }
}
class OrderListSection {
  constructor(container) {
    this.element = container;
    // this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]')); // Setup product item color swatch

    this.categoryList = this.element.querySelector(".OrderList__Categories");
    this.productListDiv = this.element.querySelector(".OrderList__ProductList");
    this.categoryInputs = this.element.querySelectorAll(
      'input[name="order_list_category"]',
    );
    this.selectedCategory = this.element.querySelector(
      'input[name="order_list_category"]:checked',
    );

    this.categoryListCarousel = new Carousel(this.categoryList); // Setup product item color swatch
    this.productListCarousel;

    this.orderItems = document.querySelectorAll("[data-order-status]");
    for (const orderItem of this.orderItems) {
      new CustomerOrderWidget(orderItem);
    }

    this.init();
  }

  async init() {
    // Add event listener to category input
    this.categoryInputs.forEach((input) => {
      input.addEventListener("change", this.handleCategoryChange.bind(this));
    });

    // Initial product list load
    await this.loadOrders();
  }

  async handleCategoryChange() {
    this.selectedCategory = this.element.querySelector(
      'input[name="order_list_category"]:checked',
    );
    await this.loadOrders();
  }

  async loadOrders() {
    await this.filterOrdersByStatus(this.selectedCategory.value);
  }

  filterOrdersByStatus(status) {
    let orderItems = document.querySelectorAll(
      ".OrderList [data-order-status]",
    );
    let orderItemsWithStatus = document.querySelectorAll(
      `.OrderList [data-order-status="${status}"]`,
    );
    for (const orderItem of orderItems) {
      orderItem.style.display = "none";
    }
    if (status && status !== "all") {
      for (const orderItem of orderItemsWithStatus) {
        orderItem.style.display = "flex";
      }
    } else if (status === "all") {
      for (const orderItem of orderItems) {
        orderItem.style.display = "flex";
      }
    } else {
      for (const orderItem of orderItems) {
        orderItem.style.display = "flex";
      }
    }
  }

  onUnload() {
    this.carousel.destroy();
  }
}
class ProductQuickView {
  constructor(product_handle, container) {
    this.element = container;
    this.productHandle = product_handle;
    this.productCarousel;
    this.quickViewModal = document.getElementById("catalog-quickview--modal");
    this.quickViewModalID = "catalog-quickview--modal";
    // for (const carousel of this.element.querySelectorAll('[data-flickity-config]')) {
    //   this.carousels.push(new Carousel(carousel, {}));
    // }

    if (window.theme.showElementStaggering) {
      // this.timeline = new TimelineLite({
      //   delay: window.theme.showPageTransition ? 0.5 : 0
      // });
    }

    this._attachListeners();
  }

  onUnload() {
    if (window.theme.showElementStaggering) {
      this.timeline.kill();
    }

    window.removeEventListener("scroll", this._onScrollListener);
  }

  _attachListeners() {
    let $this = this;
    window.addEventListener("scroll", this._onScrollListener);

    $this.element.addEventListener("click", (e) => {
      $this.renderProductDetail($this.productHandle);
      window.SimpleCore._helpers.triggerEvent("modal:open", {
        target: $this.element,
      });
    });

    document.addEventListener("so.modal:closed", (event) => {
      let renderTarget = this.quickViewModal.querySelector(
        ".Product__QuickView",
      );
      renderTarget.innerHTML = "";
    });
  }

  async renderProductDetail(productHandle) {
    if (productHandle) {
      let productDetails;
      let renderTarget = this.quickViewModal.querySelector(
        ".Product__QuickView",
      );
      let buildProductDetail = () => {
        renderTarget.innerHTML = productDetails;
        theme.accordion._init();
        new Carousel(renderTarget.querySelector("[data-flickity-config]"));
        // theme.accordion.toggle_item(this.quickViewModal.querySelector(".Product__Info .Accordion__Item"));
        return;
      };

      await fetch(`/products/${productHandle}?view=catalog`)
        .then((response) => response.text())
        .then((product) => (productDetails = product));

      renderTarget.classList.add("Product--Catalog");

      return buildProductDetail(productDetails);
    }
  }
}
class Carousel {
  constructor(element, options = {}, overrideSettings = {}) {
    this.element = element;
    this.initialConfig = Object.assign(
      JSON.parse(element.getAttribute("data-flickity-config")),
      overrideSettings,
    );
    this.options = options;

    this._attachListeners();
    this._build();
  }

  destroy() {
    this.flickityInstance.destroy();

    if (this.initialConfig["breakpoints"] !== undefined) {
      document.removeEventListener(
        "breakpoint:changed",
        this._onBreakpointChangedListener,
      );
    }
  }

  getFlickityInstance() {
    return this.flickityInstance;
  }

  selectCell(index, shouldPause = false, shouldAnimate = true) {
    if (shouldPause) {
      this.flickityInstance.pausePlayer();
    }

    this.flickityInstance.select(index, false, !shouldAnimate);
  }

  next() {
    this.flickityInstance.next();
  }

  previous() {
    this.flickityInstance.previous();
  }

  pausePlayer() {
    this.flickityInstance.pausePlayer();
  }

  unpausePlayer() {
    this.flickityInstance.unpausePlayer();
  }

  resize() {
    this.flickityInstance.resize();
  }

  getSelectedIndex() {
    return this.flickityInstance.selectedIndex;
  }

  getSelectedCell() {
    return this.flickityInstance.selectedCell.element;
  }

  _attachListeners() {
    if (this.initialConfig["breakpoints"] !== undefined) {
      this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
      document.addEventListener(
        "breakpoint:changed",
        this._onBreakpointChangedListener,
      );
    }
  }

  _build() {
    const config = this._processConfig();
    this.flickityInstance = new Flickity(this.element, config);

    this._validateDraggable();

    this.selectedIndex = this.flickityInstance.selectedIndex;
    this.flickityInstance.on("resize", this._validateDraggable.bind(this));

    if (this.options["onSelect"]) {
      this.flickityInstance.on("select", () => {
        if (this.selectedIndex !== this.flickityInstance.selectedIndex) {
          this.options["onSelect"](
            this.flickityInstance.selectedIndex,
            this.flickityInstance.selectedCell.element,
          );
          this.selectedIndex = this.flickityInstance.selectedIndex;
        }
      });
    }

    if (this.options["onSlideImpression"]) {
      this.flickityInstance.on("select", () => {
        if (!this.flickityInstance.selectedCell) {
          return;
        }
        this.options["onSlideImpression"](
          this.flickityInstance.selectedIndex,
          this.flickityInstance.selectedCell.element,
        );
      });
    }

    if (this.options["onSlideInit"]) {
      if (!this.flickityInstance.selectedCell) {
        return;
      }
      this.options["onSlideInit"](
        this.flickityInstance.selectedIndex,
        this.flickityInstance.selectedCell.element,
      );
    }

    if (this.options["onSettle"]) {
      this.flickityInstance.on("settle", (index) => {
        this.options["onSettle"](
          index,
          this.flickityInstance.selectedCell.element,
        );
      });
    }

    if (this.options["onClick"]) {
      this.flickityInstance.on("staticClick", (event, pointer, cell, index) => {
        this.options["onClick"](cell, index);
      });
    }

    if (this.options["onSlideClick"]) {
      this.flickityInstance.on("staticClick", (event, pointer, cell, index) => {
        this.options["onSlideClick"](cell, index);
      });
    }

    if (this.options["onSlideChange"]) {
      this.flickityInstance.on("select", (index) => {
        this.options["onSlideChange"](this);
      });
    }

    if (this.options["onSlideHover"]) {
      let all_cells = this.flickityInstance.cells.map((cell) => cell.element);
      for (const cell of all_cells) {
        cell.addEventListener("mouseenter", () => {
          this.options["onSlideHover"](cell);
        });
      }
    }

    if (this.options["onSlideHoverOut"]) {
      let all_cells = this.flickityInstance.cells.map((cell) => cell.element);
      for (const cell of all_cells) {
        cell.addEventListener("mouseleave", () => {
          this.options["onSlideHoverOut"](cell);
        });
      }
    }
  }

  _validateDraggable() {
    const isActive = this.flickityInstance.isActive || false;

    if (!isActive || !this.flickityInstance.options["draggable"]) {
      return; // Not draggable, so nothing to do
    }

    if (
      undefined === this.flickityInstance.selectedElements ||
      this.flickityInstance.selectedElements.length ===
        this.flickityInstance.cells.length
    ) {
      this.flickityInstance.unbindDrag();
    } else {
      this.flickityInstance.bindDrag();
    }
  }

  _processConfig() {
    let config = Object.assign({}, this.initialConfig);
    delete config["breakpoints"];

    if (this.initialConfig["breakpoints"] === undefined) {
      return config; // No change, we simply return the config as it is
    }

    const breakpoints = this.initialConfig["breakpoints"];
    breakpoints.forEach((breakpoint) => {
      if (Responsive.matchesBreakpoint(breakpoint["matches"])) {
        config = Object.assign(config, breakpoint["settings"]);
      }
    });
    return config;
  }

  _onBreakpointChanged() {
    this.flickityInstance.destroy();
    this._build();
  }
}

class GeneralRules {
  constructor() {
    this.environmentRules = null;
    this.currentSessionEnvironment = sessionStorage.getItem(
      "_simplecore:page_environment",
    );
    this._setEnvironment();
    this._setEvents();
    this._init();
  }

  _setEvents() {}
  _setEnvironment() {
    if (window?._simplecore?.page_environment) {
      sessionStorage.setItem(
        "_simplecore:page_environment",
        window?._simplecore?.page_environment,
      );
      this.currentSessionEnvironment = sessionStorage.getItem(
        "_simplecore:page_environment",
      );
    }
  }
  _init() {
    if (this.currentSessionEnvironment === "segmented_offer") {
      this.environmentRules = new SegmentedOfferEnvironmentRules();
    }
  }
}
class SegmentedOfferEnvironmentRules {
  constructor() {
    this._updateHrefs();
    this._setEvents();
  }

  _setEvents() {}
  _updateHrefs() {
    const campaign = "ab22f787f2e84fcdbed547d5cb3f04fd";
    const currentHost = location.host;

    function appendCampaignParam(a) {
      // return;
      try {
        const url = new URL(a.getAttribute("href"), location.origin);

        // Only rewrite same‑host HTTP(S) links
        //
        if (
          url.protocol.startsWith("http") &&
          url.host === currentHost &&
          url.href !== "https://simpleorganic.com.br/#"
        ) {
          // If it’s already there, do nothing
          if (url.searchParams.get("c") !== campaign) {
            url.searchParams.set("c", campaign);
            a.setAttribute("href", url.toString());
          }
        }
      } catch (e) {
        // ignore invalid URLs (e.g. mailto:, tel:, javascript:)
      }
    }

    // Rewrite all existing links on load
    document.querySelectorAll("a[href]").forEach(appendCampaignParam);

    // Catch any new links added later (e.g. via AJAX or SPA framework)
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches("a[href]")) {
            appendCampaignParam(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll("a[href]").forEach(appendCampaignParam);
          }
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
}

for (const quickviewProduct of document.querySelectorAll(
  "[data-quickview-product]",
)) {
  new ProductQuickView(
    quickviewProduct.getAttribute("data-quickview-product"),
    quickviewProduct,
  );
}

if (
  document.querySelector('[data-section-type="customers-account-order-list"]')
) {
  for (const orderListComponent of [
    ...document.querySelectorAll(
      '[data-section-type="customers-account-order-list"]',
    ),
  ]) {
    new OrderListSection(orderListComponent);
  }
}
if (document.body.classList.contains("template-type--store_catalog")) {
  new ProductCatalogPage();
}

if (document.querySelector('[data-section-type="user-account"]')) {
  for (const userAccountComponent of [
    ...document.querySelectorAll('[data-section-type="user-account"]'),
  ]) {
    new UserAccountSection(userAccountComponent);
  }
}

// WhatsApp Share Button Functionality
document.addEventListener("DOMContentLoaded", function () {
  // Trigger WhatsApp share on button click
  var whatsappButtons = document.querySelectorAll(".whatsapp-button");
  whatsappButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      // Get product information
      var productName = button.getAttribute("data-product");
      var productPrice = button.getAttribute("data-price");
      var comparePrice = button.getAttribute("data-compare-price");
      var productURL = button.getAttribute("data-url");

      // Create the WhatsApp message
      var whatsappMessage =
        "Oie, vi esse produto e pensei em você! Vem conhecer a " +
        productName +
        " da Simple Organic. Garanta já a sua! 💙 Por: " +
        productPrice;

      // Add compare at price if available
      if (comparePrice && comparePrice !== productPrice) {
        whatsappMessage += " De: " + comparePrice;
      }

      whatsappMessage += "\n" + productURL;

      // Encode the message for a WhatsApp-friendly URL
      var encodedMessage = encodeURIComponent(whatsappMessage);

      // Open WhatsApp with the message
      window.location.href = "whatsapp://send?text=" + encodedMessage;
    });
  });
});

document.addEventListener("DOMContentLoaded", async function () {
  theme.homepage.init();
  // theme.whatsapp_widget._init();
  theme.accordion._init();
  theme.cart.setEvents();
  new GeneralRules();

  var truncated1 = document.getElementById("truncated1");
  var fullDescription1 = document.getElementById("fullDescription1");
  var truncated = document.getElementById("truncated");
  var fullDescription = document.getElementById("fullDescription");

  if (truncated1 && fullDescription1) {
    truncated1.addEventListener("click", function () {
      // Hide truncated content and show full description
      hideAndShow(truncated1, fullDescription1);
    });
  }

  if (truncated && fullDescription) {
    truncated.addEventListener("click", function () {
      // Hide truncated content and show full description
      hideAndShow(truncated, fullDescription);
    });
  }
  let hideAndShow = (toHide, toShow) => {
    if (toHide && toShow) {
      toHide.style.display = "none";
      toShow.style.display = "block";
    }
  };
});
